import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { TIERS, gbp } from "components/pricing/TwoPlansWithDurationSwitcher.js";

/*
 * Homepage pricing summary. The full plan picker and billing FAQ live on the
 * pricing page; repeating the whole picker here duplicated it. Figures come
 * from the same TIERS constant, so the two can't drift apart.
 */
const Row = tw.div`max-w-screen-xl mx-auto rounded-2xl bg-primary-900 text-white px-8 py-12 md:px-16 flex flex-col lg:flex-row items-center gap-10`;
const Text = tw.div`flex-1`;
const Heading = tw.h2`text-3xl sm:text-4xl font-black text-white`; // explicit: global h2 styles override inherited white
const Body = tw.p`mt-4 text-lg text-gray-200 max-w-xl`;
const Tiers = tw.ul`mt-6 grid sm:grid-cols-3 gap-4`;
const Tier = tw.li`rounded-xl bg-white/10 px-4 py-3`;
const TierSize = tw.p`text-sm text-gray-200`;
const TierPrice = tw.p`text-xl font-bold`;
const Actions = tw.div`flex flex-col gap-3 w-full lg:w-auto`;
const Primary = tw.a`text-center px-8 py-4 rounded-full bg-white text-primary-900 font-bold hocus:bg-gray-200 transition duration-300`;
const Secondary = tw.a`text-center px-8 py-4 rounded-full border-2 border-white text-white font-bold hocus:bg-white hocus:text-primary-900 transition duration-300`;

export default () => (
  <Container>
    <ContentWithPaddingXl>
      <Row>
        <Text>
          <Heading>One plan. Every feature.</Heading>
          <Body>
            Priced by the size of your organisation, never per user — with nothing held back
            for a higher tier.
          </Body>
          <Tiers>
            {TIERS.map(t => (
              <Tier key={t.slug}>
                <TierSize>{t.label} employees</TierSize>
                <TierPrice>{gbp(t.annual)}<span tw="text-sm font-normal text-gray-200"> / year</span></TierPrice>
              </Tier>
            ))}
          </Tiers>
        </Text>
        <Actions>
          <Primary href="/PricingPage">See pricing</Primary>
          <Secondary href="/contact">Book a demo</Secondary>
        </Actions>
      </Row>
    </ContentWithPaddingXl>
  </Container>
);
